import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { components, store, localize } from 'linksoft';
import { Provider } from 'react-redux';

import service from '../../services/service';
import Overlay from '../../common/overlay';

const Resx = localize('App');

class ProfilePreview extends Component {

  static PropTypes = {
    profilePreviewUrl: PropTypes.string.isRequired,
    profileId: PropTypes.number.isRequired,
    fileGuid: PropTypes.string.isRequired,
    onClosePreview: PropTypes.func.isRequired,
  }

  state = {
    charts: []
  }

    componentDidMount = () => {
        const { profileId, fileGuid, profilePreviewUrl } = this.props;
        // load data
        service.profilePreview(profileId, fileGuid, profilePreviewUrl).then(data => {
            data.forEach(chart => {
                if (chart.options.scales.xAxes[0].type == 'time') {
                    chart.options.scales.xAxes[0].time.min = chart.data.scalingSettings.dataXAxisMinPos
                    chart.options.scales.xAxes[0].time.max = chart.data.scalingSettings.dataXAxisMaxPos
                }
                else
                {
                    chart.options.scales.xAxes[0].min = chart.data.scalingSettings.dataXAxisMinPos
                    chart.options.scales.xAxes[0].max = chart.data.scalingSettings.dataXAxisMaxPos
                }                   
            });
            this.setState({ charts: data });
        }
    );
  }

  closeOnClickHandler = () => {
    this.props.onClosePreview();
  }

  render = () => {
    return (
      <Overlay
        onCloseButtonClick={this.closeOnClickHandler}
        overlayShadeClass={!this.state.charts.length ? 'uploading-measurements' : ''}>
        {
          !!this.state.charts.length && (
            <div className="ProfilePreview" style={{ width: '80vw' }}>
              <div className="intro-text">
                <p>{Resx.App.MeasurementImport_ProfilePreview_IntroText_Line1}</p>
                <p>{Resx.App.MeasurementImport_ProfilePreview_IntroText_Line2}</p>
              </div>
              <div className="content" onClick={stopPropagation}>
                {this.state.charts.map(c => this.renderChart(c))}
              </div>
            </div>
          )
        }
      </Overlay>);
  }

  renderChart = props => {
    const Component = components.get()['measurement-chart'];

    return (
      <Provider key={props.chartName} store={store.get()}>
        <Component {...props} />
      </Provider>);
  }
}

const stopPropagation = e => {
  e.stopPropagation();
};

export default ProfilePreview;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-validator/validator-table/profile-preview/profile-preview.js